import { nanoid } from 'nanoid';
import moment from 'moment';
import { TimelineItemTypeType } from '@app-types/timetable';
import { TimelineItemModelType } from '../../TimelineItem';
import { GetTimeLineIntervalSlotsForAllGroupsArgs } from '../types';

/**
 * Individual interval for all groups
 * @param timelineGroups
 * @param startTime
 * @param endTime
 */
export const getTimeLineIntervalSlotsForAllGroups = ({
  timelineGroups,
  startTime,
  endTime,
}: GetTimeLineIntervalSlotsForAllGroupsArgs): TimelineItemModelType[] => {
  return timelineGroups.map((timelineGroup) => ({
    id: nanoid(),
    groupID: timelineGroup.id,
    title: 'Interval',
    duration: moment.duration(endTime.diff(startTime)).asHours(),
    color: 'lightseagreen',
    batchClassID: timelineGroup.id,
    itemType: TimelineItemTypeType.interval,
    startTime,
    endTime,
    elementID: null,
    lecturerID: null,
    locationID: undefined,
    subjectName: undefined,
    published: false,
    batchClassName: null,
    batchName: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeItem: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    moveItem: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setEndTime: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setStartTime: () => {},
    dbId: null,
  }));
};
